import React from "react";
import {
  AreaChart,
  Area,
  XAxis,
  YAxis,
  CartesianGrid,
  ResponsiveContainer,
} from "recharts";
import "./AnalyticsChart.css";

const chart_data = [
  { x: 1, v: 30 },
  { x: 2, v: 65 },
  { x: 3, v: 42, label: "+18%" },
  { x: 4, v: 85 },
  { x: 5, v: 38, label: "-10%" },
  { x: 6, v: 60 },
  { x: 7, v: 28 },
  { x: 8, v: 45, label: "+27%" },
  { x: 9, v: 88 },
];

const CustomDotLabel = ({ cx, cy, payload }) => {
  if (!payload.label) return null;

  return (
    <g className="chart_point_group">
      <circle cx={cx} cy={cy} r={4} className="chart_point_dot" />
      <text
        x={cx}
        y={cy - 14}
        textAnchor="middle"
        className="chart_point_label"
      >
        {payload.label}
      </text>
    </g>
  );
};


const CustomYAxisTick = ({ x, y, payload }) => {
  return (
    <text
      x={x - 6}
      y={y + 4}
      textAnchor="end"
      className="chart_yaxis_tick"
    >
      {payload.value}%
    </text>
  );
};


const AnalyticsChart = () => {
  return (
   <div className="chart_card_wrapper">
      <ResponsiveContainer width="100%" height={235}>
        <AreaChart
          data={chart_data}
          margin={{ top: 10, right: 20, left: 0, bottom: 0 }}
        >
          
          <CartesianGrid
            vertical={false}
            strokeDasharray="3 3"
            className="chart_grid_line"
          />

          {/* X AXIS */}
          <XAxis dataKey="x" hide />

      
          <YAxis
            domain={[0, 95]}
            ticks={[0, 42, 95]}
            axisLine={false}
            tickLine={false}
            tick={<CustomYAxisTick />}
            width={40}
          />

          {/* GRADIENT */}
          <defs>
            <linearGradient id="chart_area_gradient" x1="0" y1="0" x2="0" y2="1">
              <stop offset="0%" stopColor="#9ca3af" stopOpacity={0.8} />
              <stop offset="100%" stopColor="#f3f4f6" stopOpacity={0.12} />
            </linearGradient>
          </defs>

          {/* AREA */}
          <Area
            type="monotone"
            dataKey="v"
            stroke="#111827"
            strokeWidth={2}
            fill="url(#chart_area_gradient)"
            dot={<CustomDotLabel />}
            activeDot={false}
          />
        </AreaChart>
      </ResponsiveContainer>

      {/* FOOTER */}
      <div className="chart_footer_container">
        <div className="chart_footer_item">
          <p className="chart_footer_title">Relationships</p>
          <span className="chart_footer_sub">Last update at 21 Nov</span>
        </div>

        <div className="chart_footer_item">
          <p className="chart_footer_title">Average Risk</p>
          <span className="chart_footer_sub">Last update at 18 Nov</span>
        </div>

        <div className="chart_footer_item">
          <p className="chart_footer_title">Average Coverage</p>
          <span className="chart_footer_sub">Last update at 18 Nov</span>
        </div>
      </div>
    </div>
  );
};

export default AnalyticsChart;
